export default __webpack_public_path__ + "static/media/pokemon-yellow.a5c5440b.svg";